import SDGicon01 from './SDGs/1.svg';
import SDGicon02 from './SDGs/2.svg'
import SDGicon03 from './SDGs/3.svg';
import SDGicon04 from './SDGs/4.svg'
import SDGicon05 from './SDGs/5.svg';
import SDGicon06 from './SDGs/6.svg'
import SDGicon07 from './SDGs/7.svg';
import SDGicon08 from './SDGs/8.svg'
import SDGicon09 from './SDGs/9.svg';
import SDGicon10 from './SDGs/10.svg'
import SDGicon11 from './SDGs/11.svg';
import SDGicon12 from './SDGs/12.svg'
import SDGicon13 from './SDGs/13.svg';
import SDGicon14 from './SDGs/14.svg'
import SDGicon15 from './SDGs/15.svg';
import SDGicon16 from './SDGs/16.svg'
import SDGicon17 from './SDGs/17.svg';
import clearSDGFilterIcon from './SDGs/clearSDGFilter.svg';
import SDGicon from './SDG.svg'

export {
    SDGicon, 
    SDGicon01, 
    SDGicon02, 
    SDGicon03, 
    SDGicon04, 
    SDGicon05, 
    SDGicon06, 
    SDGicon07, 
    SDGicon08, 
    SDGicon09, 
    SDGicon10, 
    SDGicon11, 
    SDGicon12, 
    SDGicon13, 
    SDGicon14, 
    SDGicon15, 
    SDGicon16, 
    SDGicon17, 
    clearSDGFilterIcon,
};

export const SDGs = [
    { 
        icon: SDGicon01,
        index: 1,
        goal: "No Poverty",
        url: "https://sdgs.un.org/goals/goal1" 
    },
    { 
        icon: SDGicon02,
        index: 2,
        goal: "Zero Hunger",
        url: "https://sdgs.un.org/goals/goal2" 
    },
    { 
        icon: SDGicon03,
        index: 3,
        goal: "Good Health and Well-Being",
        url: "https://sdgs.un.org/goals/goal3" 
    },
    { 
        icon: SDGicon04,
        index: 4,
        goal: "Quality Education",
        url: "https://sdgs.un.org/goals/goal4" 
    },
    { 
        icon: SDGicon05,
        index: 5,
        goal: "Gender Equality",
        url: "https://sdgs.un.org/goals/goal5" 
    },
    { 
        icon: SDGicon06,
        index: 6,
        goal: "Clean Water and Sanitation",
        url: "https://sdgs.un.org/goals/goal6" 
    },
    { 
        icon: SDGicon07,
        index: 7,
        goal: "Affordable and Clean Energy",
        url: "https://sdgs.un.org/goals/goal7" 
    },
    { 
        icon: SDGicon08,
        index: 8,
        goal: "Decent Work and Economic Growth",
        url: "https://sdgs.un.org/goals/goal8" 
    },
    { 
        icon: SDGicon09,
        index: 9,
        goal: "Industry, Innovation and Infrastructure",
        url: "https://sdgs.un.org/goals/goal9" 
    },
    { 
        icon: SDGicon10,
        index: 10,
        goal: "Reduced Inequalities",
        url: "https://sdgs.un.org/goals/goal10" 
    },
    { 
        icon: SDGicon11,
        index: 11,
        goal: "Sustainable Cities and Communities",
        url: "https://sdgs.un.org/goals/goal11" 
    },
    { 
        icon: SDGicon12,
        index: 12,
        goal: "Responsible Consumption and Production",
        url: "https://sdgs.un.org/goals/goal12" 
    },
    { 
        icon: SDGicon13,
        index: 13,
        goal: "Climate Action",
        url: "https://sdgs.un.org/goals/goal13" 
    },
    { 
        icon: SDGicon14,
        index: 14,
        goal: "Life below Water",
        url: "https://sdgs.un.org/goals/goal14" 
    },
    { 
        icon: SDGicon15,
        index: 15,
        goal: "Life on Land",
        url: "https://sdgs.un.org/goals/goal15" 
    },
    { 
        icon: SDGicon16,
        index: 16,
        goal: "Peace, Justice and Strong Institutions",
        url: "https://sdgs.un.org/goals/goal16" 
    },
    { 
        icon: SDGicon17,
        index: 17,
        goal: "Partnerships for the Goals",
        url: "https://sdgs.un.org/goals/goal17" 
    },
]

export const SDGIconBackgroundColors = [
    '#e5243b',
    '#dda63a',
    '#4c9f38',
    '#c5192d',
    '#ff3a21',
    '#26bde2',
    '#fcc30b',
    '#a21942',
    '#fd6925',
    '#dd1367',
    '#fd9d24',
    '#bf8b2e',
    '#3f7e44',
    '#0a97d9',
    '#56c02b',
    '#00689d',
    '#19486a',
];